import React from 'react'
import { Form, Input, Button, Modal, InputNumber, Switch, Radio } from 'antd'

const FormItem = Form.Item
const { TextArea } = Input

class ItemForm extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.handleOnSubmit = this.handleOnSubmit.bind(this)
    this.handleOnDelete = this.handleOnDelete.bind(this)
  }

  handleOnSubmit(e) {
    e.preventDefault()
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (err) {
        return
      }
      this.props.onSubmit(values)
    })
  }

  handleOnDelete(e) {
    e.preventDefault()
    const handleOnOk = () => { this.props.onDelete() }
    Modal.confirm({
      title: 'Удалить запись',
      content: 'Вы действительно хотите удалить запись?',
      okType: 'danger',
      okText: 'Да',
      cancelText: 'Нет',
      onOk() {
        handleOnOk()
      },
      onCancel() {
        // console.log('Cancel')
      },
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
        md: { span: 10 },
      },
    }
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 12,
          offset: 7,
        },
      },
    }
    const isCreateForm = this.props.type === 'create'

    return (
      <Form onSubmit={this.handleOnSubmit}>
        <FormItem label='Название' {...formItemLayout}>
          {getFieldDecorator('s_name', {
            rules: [{ required: true, message: 'Пожалуйста введите название.' }],
          })(<Input placeholder='Название' />)}
        </FormItem>

        <FormItem label='Логин' {...formItemLayout}>
          {getFieldDecorator('s_login', {
            rules: [{ required: true, message: 'Пожалуйста введите логин.' }],
          })(<Input placeholder='Логин' />)}
        </FormItem>

        <FormItem label='Пароль' {...formItemLayout}>
          {getFieldDecorator('s_password', {
            rules: [{ required: !!isCreateForm, message: 'Пожалуйста введите пароль.' }],
          })(<Input placeholder='Пароль' type='password' />)}
        </FormItem>

        <FormItem label='Блокировка' {...formItemLayout}>
          {getFieldDecorator('n_lock', {
            valuePropName: 'checked',
            initialValue: false,
            rules: [{ required: false, message: 'Блокировка.' }],
          })(<Switch />)}
        </FormItem>

        <FormItem {...tailFormItemLayout}>
          <Button
            loading={this.props.isCreateItemLoading || this.props.isEditItemLoading}
            type='primary'
            htmlType='submit'
            style={{ marginRight: '12px' }}
          >
            {isCreateForm ? 'Создать' : 'Сохранить'}
          </Button>
          {
            !isCreateForm &&
            <Button
              loading={this.props.isDeleteItemLoading}
              type='danger'
              htmlType='button'
              onClick={this.handleOnDelete}
            >
              Удалить
            </Button>
          }
        </FormItem>
      </Form>
    )
  }
}

const CustomizedForm = Form.create({
  onFieldsChange(props, changedFields) {
    props.onFieldsChange(changedFields)
  },
  mapPropsToFields(props) {
    const { formFieldValues = {} } = props
    return {
      s_name: Form.createFormField(formFieldValues.s_name),
      s_login: Form.createFormField(formFieldValues.s_login),
      s_password: Form.createFormField(formFieldValues.s_password),
      n_lock: Form.createFormField(formFieldValues.n_lock),
    }
  },
  // onValuesChange(_, values) {
  //   console.log(values)
  // },
})(ItemForm)

export default CustomizedForm



// WEBPACK FOOTER //
// src/containers/UserForm/Form.jsx